import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import posed, { PoseGroup } from 'react-pose'

const PosedText = posed.p({
  enter: {
    opacity: 1,
    x: 0
  },
  
  exit: {
    opacity: 0,
    x: -10
  }
})

const Wrapper = styled.div`
  color: ${props => props.theme.colors.grey.lightest};
  padding: 25px;

  ${media.lg`
    padding: 25px 25px 55px;
  `}
`

const Title = styled(PosedText)`
  font-size: 22px;
  font-weight: 700;
`

const Paragraph = styled(PosedText)`
  font-size: 16px;
`

export default class Text extends Component {
  render() {
    const {
      title,
      text,
    } = this.props
    
    return(
      <Wrapper>
        <PoseGroup withParent={false}>
          <Title key={Math.random()}>{title}</Title>
          <Paragraph key={Math.random()}>{text}</Paragraph>
        </PoseGroup>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/Text.js